import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url, URLS } from '@wix/da-url';
import BooleanInput from '@wix/da-ds/pkg/formControls/dsPresets/BooleanInput';
import { useSubmitField } from '../../../hooks/useSubmitField';

import s from './OAuth2Upgrade21Checkbox.scss';

const FIELD_NAME = 'oauth2Upgrade21';

const OAuth2Upgrade21Checkbox: React.FC<{}> = () => {
  const { t } = useTranslation();
  const {
    id,
    field: { onChange, value },
  } = useSubmitField(FIELD_NAME, {
    initAdapter: () => false,
    submitAdapter: ({ oauth2Upgrade21 }) => (oauth2Upgrade21 ? { oauth2_upgrade_21: true } : {}),
  });

  const sectionTitleId = `${id}-section-title`;

  return (
    <div className={s['root']}>
      <h3 className={s['sectionTitle']} id={sectionTitleId}>
        {t('deviationSubmit.form.app.oauth2Upgrade21.label')}
      </h3>
      <div className={s['box']} role="group" aria-labelledby={sectionTitleId}>
        <BooleanInput
          name={FIELD_NAME}
          id={id}
          value={value}
          onChange={onChange}
          type="checkbox"
          size="small"
          label={
            <span className={s['labelText']}>
              {t('deviationSubmit.form.app.oauth2Upgrade21.description')}
              <span className={s['irreversible']}>
                {t('deviationSubmit.form.app.oauth2Upgrade21.irreversible')}
              </span>
              <a
                className={s['learnMore']}
                href={Url.to(URLS.DEVELOPERS_AUTH)}
                rel="noopener noreferrer"
                target="_blank"
              >
                {t('deviationSubmit.form.app.oauth2Upgrade21.learnMore')}
              </a>
            </span>
          }
          noBottomSpacing={false}
        />
      </div>
    </div>
  );
};
OAuth2Upgrade21Checkbox.displayName = 'OAuth2Upgrade21Checkbox';

export default OAuth2Upgrade21Checkbox;
